import { ControllerPaletteColor } from './__palette-color';

export enum ControllerDropzoneColor {
  PanelBorder = ControllerPaletteColor.Gray800,
  PanelBg = ControllerPaletteColor.Gray950,
  PanelFg = ControllerPaletteColor.Gray600,
}
